/*=========================================================================================
  File Name: moduleChatGetters.js
  Description: Chat Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import contacts from '@/views/apps/chat/contacts'

export default {
  chatDataOfUser: (state) => (id) => {
    return state.chats[Object.keys(state.chats).find((key) => key === id)];
  },
  chatContacts: (state, getters) => {
    const chatContacts = state.chatContacts.filter((contact) =>
      contact.displayName.toLowerCase().includes(state.chatSearchQuery.toLowerCase())
    );

    chatContacts.sort((x, y) => {
      const timeX = getters.chatLastMessaged(x.uid).time;
      const timeY = getters.chatLastMessaged(y.uid).time;
      return new Date(timeY) - new Date(timeX);
    });

    return chatContacts.sort((x, y) => {
      const chatDataX = getters.chatDataOfUser(x.uid);
      const chatDataY = getters.chatDataOfUser(y.uid);
      if (chatDataX && chatDataY) return chatDataY.isPinned - chatDataX.isPinned;
      else return 0;
    });
  },
  contacts: (state) =>
    state.contacts.filter((contact) => contact.name.toLowerCase().includes(state.chatSearchQuery.toLowerCase())),
  contact: (state) => (contactId) => state.contacts.find((contact) => contact.id == contactId),
  chats: (state) => state.chats,
  chatUser: (state, getters, rootState, rootGetters) => (id) =>
    state.contacts.find((contact) => contact.uid === id) || rootGetters.getUser,
  chatNewestMessage: (state, getters) => {
    let chats = [];

    for (const [key, value] of Object.entries(state.chats)) {
      chats.push.apply(chats, value["msg"]);
    }

    chats.sort((x, y) => {
      const timeX = x.timestamp * 1000;
      const timeY = y.timestamp * 1000;
      return new Date(timeY) - new Date(timeX);
    });

    return chats.length ? chats[0] : null;
  },

  chatLastMessaged: (state, getters) => (id) => {
    let message;
    if (getters.chatDataOfUser(id)) {
      message = getters.chatDataOfUser(id).msg.slice(-1)[0];
      return (message = {
        ...message,
        sender: getters.chatUser(message.sendBy),
      });
    }
    return false;
  },
  chatUnseenMessages: (state, getters, rootState) => (id) => {
    let unseenMsg = 0;
    const chatData = getters.chatDataOfUser(id);
    if (chatData) {
      chatData.msg.map((msg) => {
        if (
          !msg.isSeen &&
          msg.sendBy !== rootState.appUser.appActiveUser.name &&
          !Object.keys(msg.seenBy).includes(rootState.appUser.appActiveUser.id.toString())
        )
          unseenMsg++;
      });
    }

    return unseenMsg;
  },
  chatParticipants: (state, getters) => (id) => {
    let participants = [];
    const chatData = getters.chatRoom(id);
    if (chatData) {
      for (const [user_id, user] of Object.entries(chatData.members)) {
        participants.push({
          ...user,
          user_id: user_id,
        });
      }
    }
    return participants;
  },
  chatIsParticipants: (state, getters) => (roomId, id) => {
    const participants = getters.chatParticipants(roomId);
    if (participants) {
      let participantIds = participants.map((user) => {
        return user.id;
      });

      return participantIds.includes(id);
    }
    return false;
  },
  chatUser: (state, getters) => (id) => {
    const user = getters.contact(id);
    if (user) return user;
    else false;
  },
  getChatRoomByTopic: (state) => (topic) => {
    return state.chatRooms.filter(function(chatRoom) {
      if (chatRoom.topic) return chatRoom.topic.toLowerCase().includes(topic);
    });
  },
  chatRooms: (state) =>
    state.chatRooms.filter(function(chatRoom) {
      if (chatRoom.topic) return chatRoom.topic.toLowerCase().includes(state.chatSearchQuery.toLowerCase());
    }),
  chatRoom: (state) => (chatRoomId) => state.chatRooms.find((chatRoom) => chatRoom.chatUID === chatRoomId),
  lastSentMessage: (state, getters) => (id) => {
    let message = false;
    const room = getters.chatRoom(id);
    if (room) {
      message = room.lastSentMessage;
    }
    return message;
  },
  chatMessage: (state, getters) => (room, messageUID) => {
    let message = false;
    const chatData = getters.chatDataOfUser(room);

    if (chatData) {
      message = chatData.msg.find((value) => value.messageUID == messageUID);
      message = {
        ...message,
        sender: getters.chatUser(message.sendBy),
      };
    }

    return message;
  },
};
